import moment from "moment/moment";
import "moment/locale/fr";

export  const SamaDate = ({mydate}) => {
    moment.locale("fr");
    const timeIMS = mydate?.seconds * 1000 + mydate?.nanoseconds / 1000000;
    return moment(timeIMS).format("LLLL");
  };
